import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { CourseExportDetail } from '../../../../pages/course-export/CourseExportDetail';
import { courseExportDetailParamsSchema } from '../../../../routing/schemas';

export const Route = createFileRoute('/_private/_home/course-exports/$course_version_guid')({
  params: {
    parse: (rawParams) => courseExportDetailParamsSchema.parse(rawParams),
    stringify: (params) => params,
  },
  component: CourseExportDetailRoute,
});

function CourseExportDetailRoute() {
  const { apiClient } = Route.useRouteContext();
  return <CourseExportDetail portalApiClient={apiClient} />;
}
